import React, { PureComponent } from 'react'
import { string, func, bool } from 'prop-types'
import DefaultComponentLayout, { LayoutContent } from '../../../common/Layout/index'
import I18nMessage from '../../../common/I18nMessage'
import Confirm from '../../../common/Confirm'
import './createdAccount.scss'

const trackInfo = {
  eventName: 'CreateConfirm',
  widget: 'create_confirm',
  pageType: 'create confirm',
}

class CreatedAccount extends PureComponent {
  static propTypes = {
    Header: func,
    email: string.isRequired,
    defaultHandleSignupSuccess: func,
    configureTrack: func.isRequired,
    sace: bool,
  }

  static defaultProps = {
    Header: null,
    defaultHandleSignupSuccess: undefined,
    sace: false,
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'CreateConfirm',
      widget: 'create_confirm',
      pageType: 'create confirm',
    })
  }

  render() {
    const {
      email, defaultHandleSignupSuccess: defaultHandleComplete,
      Header, ...rest
    } = this.props

    return (
      <DefaultComponentLayout nameSpace="passport__confirmation" Header={Header}>
        <LayoutContent title message="passport.signup.createdAccount.title" />
        <LayoutContent
          subTitle
          message="passport.signup.createdAccount.subTitle"
          className="text-font-18 font-weight-600"
        />
        <LayoutContent main>
          <I18nMessage id="passport.signup.createdAccount.notice.no.email" params={{ 0: `<b>${email}</b>` }} className="text-font-14 passport__wordbreak" />
          <Confirm
            trackInfo={trackInfo}
            handleComplete={defaultHandleComplete}
            {...rest}
          />
          <hr className="active-branded" />
          <div className="passport__confirmation__benefits text-font-12 active-branded">
            <div className="passport__confirmation__benefits__titile">
              <I18nMessage id="passport.signup.createdAccount.withYour" />
            </div>
            <br />
            <ul className="passport__confirmation__benefits__list">
              <li><I18nMessage id="passport.signup.createdAccount.accessEvents" /></li>
              <li><I18nMessage id="passport.signup.createdAccount.post" /></li>
              <li><I18nMessage id="passport.signup.createdAccount.accessOther" /></li>
            </ul>
          </div>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default CreatedAccount
